var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.62132C16.8978 3.2235 17.4374 3 18 3C18.2786 3 18.5544 3.05487 18.8118 3.16148C19.0692 3.26808 19.303 3.42434 19.5 3.62132C19.697 3.8183 19.8532 4.05216 19.9598 4.30953C20.0665 4.5669 20.1213 4.84274 20.1213 5.12132C20.1213 5.3999 20.0665 5.67574 19.9598 5.93311C19.8532 6.19048 19.697 6.42434 19.5 6.62132L7 19.1213L3 20.1213L4 16.1213L16.5 3.62132Z",
    stroke: "#951B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.a03fac5a8eac54157ec61bdac17ea18e.svg";
export { ForwardRef as ReactComponent };